import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Questions = () => {
  return (
    <>
      {/* Primer acordeón */}
      <Accordion
        sx={{
          background: 'rgb(246, 246, 246)',
          boxShadow: 'none',
          margin: 0,
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            flexDirection: 'row-reverse',
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(90deg)',
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
              marginRight: '-8px',
              marginLeft: '16px',
            },
            alignItems: 'center',
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography sx={{ marginLeft: '10px' }}>
            <strong>¿En qué consiste el servicio de Diagnóstico y Reparación?</strong>
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography>
            Tras un primer diagnóstico realizado a través del chat del servicio de Ayuda Tecnológica Online, si la incidencia que presenta su equipo no se puede solucionar de forma remota, un técnico especializado se desplazará a su domicilio para resolverla.

            En ocasiones, cuando el diagnóstico online indica claramente la necesidad de actuar sobre el equipo en un taller especializado externo, se gestiona la recogida del equipo del usuario por parte de un servicio de mensajería. Con esta gestión, se busca la mayor agilidad posible, y de cara al usuario ofrecer la opción más cómoda y eficaz para el tratamiento de su incidencia.
          </Typography>
        </AccordionDetails>
      </Accordion>

      {/* Segundo acordeón */}
      <Accordion
        sx={{
          background: 'rgb(246, 246, 246)',
          boxShadow: 'none',
          margin: 0,
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          sx={{
            flexDirection: 'row-reverse',
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(90deg)',
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
              marginRight: '-8px',
              marginLeft: '16px',
            },
            alignItems: 'center',
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography sx={{ marginLeft: '10px' }}>
            <strong>¿Qué incluye este servicio?</strong>
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography>
            Este servicio incluye la mano de obra y desplazamiento. De cara al cumplimiento de la política de software legal, cualquier actuación sobre los Sistemas Operativos y aplicaciones soportadas estará supeditada a la posesión de una copia legítima de los mismos, entendiéndose esta como la clave y el medio de instalación válidos facilitados por el fabricante.

            Las piezas, accesorios o software que se detecten necesarios para resolver la incidencia, correrán a cargo del usuario. Se notificará al usuario dicha necesidad y se presentará un presupuesto no vinculante, con el objetivo de facilitar la resolución de la incidencia.
          </Typography>
        </AccordionDetails>
      </Accordion>

      {/* Tercer acordeón */}
      <Accordion
        sx={{
          background: 'rgb(246, 246, 246)',
          boxShadow: 'none',
          margin: 0,
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
          sx={{
            flexDirection: 'row-reverse',
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(90deg)',
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
              marginRight: '-8px',
              marginLeft: '16px',
            },
            alignItems: 'center',
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography sx={{ marginLeft: '10px' }}>
            <strong>¿Qué garantía ofrece la reparación?</strong>
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography>
            La garantía sobre el servicio prestado es la que marque la ley vigente. Sólo cubre malos funcionamientos debidos a instalaciones o reparaciones, en aquellos sistemas informáticos, propiedad del usuario, sobre los que hayamos trabajado directamente, y nunca sobre sistemas en los que no hayamos llevado a cabo ninguna actuación, salvo que se demuestre que el trabajo realizado en un sistema haya afectado al funcionamiento de otro sistema directamente relacionado con él. El plazo de garantía comienza a partir de la fecha de finalización de los trabajos. La garantía no cubre reconfiguraciones e reinstalaciones debidas a nuevas especificaciones aportadas por el usuario una vez finalizados los trabajos.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default Questions;
